import React, { useState } from 'react'
import { useContext } from 'react';
import { createContext } from 'react';
import { useEffect } from 'react';

const WindowSizeContext=createContext();

export const useWindowSize=()=>{
  return useContext(WindowSizeContext)
}

export default function WindowSizeContextProvider({children}) {
const [innerWidth,setInnerWidth]=useState(window.innerWidth);
const [innerHeight,setInnerHeight]=useState(window.innerHeight)

useEffect(()=>{

  const resize=()=>{
    setInnerWidth(window.innerWidth)
    setInnerHeight(window.innerHeight);
  }
  window.addEventListener('resize',resize)

  return()=>{
    window.removeEventListener('resize',resize)
  }
},[])


  return (
   <WindowSizeContext.Provider value={{innerWidth,innerHeight}}>
    {children}
   </WindowSizeContext.Provider>
  )
}
